import React from 'react';
import agent from '../../agent.js'
import bg from '../../images/login/login_bg.svg';
import logo from '../../images/login/logo_uni.svg';
import bottom_pattern from '../../images/login/bottom_pattern.svg';
import bottom_pattern2 from '../../images/login/bottom_pattern_2.svg';
import './Login.css'
export default class Login extends React.Component {

    constructor(props) {
        super(props);
        this.email = "";
        this.password = "";
        this.changeEmail = ev => this.email = ev.target.value;
        this.changePassword = ev => this.password = ev.target.value;
        this.forgotPassword = null;

        this.submitForm = (email, password) => ev => {
            ev.preventDefault();
            agent.Auth.login(this.email, this.password, this.props.onSubmit, this.props.onError);

        };
    }
    componentDidMount() {
    }

    componentWillUnmount() {
    }
    render() {
        const email = this.props.email;
        const password = this.props.password;
        return (
            <div className="login-page">
                <img src={logo} className="login-logo" alt="Корпоративный Университет РЖД" />
                <div className='login-title'><p className='login-title-text'>УПРАВЛЕНИЕ ЖЕЛЕЗНОДОРОЖНЫМ ТРАСНПОРТОМ</p></div>
                <img src={bg} className="login-bg-element" alt="" />
                <img src={bottom_pattern} className="login-bottom-pattern" alt="" />
                <img src={bottom_pattern2} className="login-bottom-pattern-2" alt="" />
                <form className="login-card" onSubmit={this.submitForm(email, password)}>
                    <div className="login-card-component pt-30">
                        <input
                            className="login-input-field"
                            type="text"
                            placeholder="ЛОГИН"
                            value={email}
                            onChange={this.changeEmail} />
                    </div>
                    <div className="login-card-component pt-20">
                        <input
                            className="login-input-field"
                            type="password"
                            placeholder="ПАРОЛЬ"
                            value={password}
                            onChange={this.changePassword} />
                    </div>
                    <div className="login-card-component pt-60">
                        <button
                            className="main-btn"
                            type="submit"
                            disabled={this.props.inProgress}>
                            ВОЙТИ
                        </button>
                    </div>
                    <div>
                        <p style={{"marginBottom": 0}} className="text-small">Логин и пароль Вы можете получить у куратора программы.</p>
                    </div>
                    <div style={{marginTop:"10px"}}>
                        <a href="https://api.rzd.levellab.ru/files/upload/privacy_policy.pdf" className="text-small">Политика конфиденциальности</a>
                    </div>
                    <div>
                        <a href="https://api.rzd.levellab.ru/files/upload/terms_of_use.pdf" className="text-small">Согласие на обработку персональных данных</a>
                    </div>
                    <div>
                        <a href="https://api.rzd.levellab.ru/files/upload/site_usd.pdf" className="text-small">Использование сайта</a>
                    </div>
                </form>

            </div>
        );
    }
}
